import {useCookieConsentContext} from '@use-cookie-consent/react';

/**
 * A custom hook that provides access to detailed tracking consent information from cookies.
 * This hook wraps the `useCookieConsent` hook and extracts the `detailedConsent` object,
 * which contains information about the user's consent preferences for different categories
 * of tracking, such as analytics or marketing. It allows components to easily determine
 * whether specific tracking scripts or services should be loaded based on user choice.
 *
 * @returns An object containing `detailedConsent`, which reflects the user's consent state for various tracking categories.
 *
 * @example
 * ```tsx
 * const { detailedConsent } = useTracking();
 *
 * if (detailedConsent?.Analytics.consented) {
 *   // Load analytics tracking
 * }
 * ```
 */
export const useTracking = () => {
    const {consent} = useCookieConsentContext();

    return {consent};
};